import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

// Components
import DepartmentsModal from './DepartmentsModal.component';
import DepartmentsTable from './Table';

// Assets
import DepartmentIcon from 'assets/DepartmentIcon';

// Selectors
import { selectDealershipDepartments } from 'services/DealershipSettings/selectors';

// Styles
import colors from 'styles/colors';
import { Section, SectionContent, SectionHeader, SectionHeaderTitle } from 'styles/cards';
import { DepartmentsBodyContainer, EmptyDepartmentsContainer } from '../styles';

const DepartmentsCard = () => {
  const departments = useSelector(selectDealershipDepartments());

  const isEmpty = departments.size === 0;

  return (
    <Section>
      <SectionHeader>
        <SectionHeaderTitle>
          <DepartmentIcon color={colors.blue} />
          <FormattedMessage id="views.FleetSettings.Departments.title" />
        </SectionHeaderTitle>
      </SectionHeader>
      <SectionContent>
        <DepartmentsBodyContainer emptyState={isEmpty}>
          {isEmpty ? (
            <EmptyDepartmentsContainer>
              <DepartmentIcon color={colors.blue} />
              <FormattedMessage id="views.FleetSettings.Departments.emptyDescription" />
            </EmptyDepartmentsContainer>
          ) : (
            <DepartmentsTable />
          )}
          <DepartmentsModal.DepartmentButton />
        </DepartmentsBodyContainer>
      </SectionContent>
    </Section>
  );
};

export default DepartmentsCard;
